




































































import { Component, Model, Prop } from 'vue-property-decorator';

import loadImage from 'blueimp-load-image';

import UploadService from '@/api/ImageUploadService';

import eventBus from '@/utils/eventBus';
import ModalOptions from '@/components/Modal/ModalOptions';

import InputBase from './InputBase.vue';
import InputWrapper from './InputWrapper.vue';
import Dropzone from '../Dropzone/Dropzone.vue';
import ChooseImage from '../ChooseImage/ChooseImage.vue';
import { IImageData } from '@/components/ImageUpload/ImageData';
import { treatError } from '@/utils';
import { dataURItoBlob } from '@/utils/image';
import TrashIcon from '@/components/icons/Trash.vue';
import UploadIcon from '@/components/icons/ArrowUpload.vue';
import { HTMLInputEvent } from '@/components/TextArea/TextAreaModel';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import ImageEmptyStateIcon from '@/components/icons/ImageEmptyState.vue';
import segmentIo from '@/utils/segment.io';

export type ImageUploadBlockValue = {
  imageFile?: File | null;
  imageUrl: string;
  imageName?: string;
};
const initialState = () => ({ imageFile: null, imageUrl: '' });

@Component<OfferImageUploadCreation>({
  components: {
    InputWrapper,
    Dropzone,
    ChooseImage,
    TrashIcon,
    UploadIcon,
    Typography,
    ImageEmptyStateIcon
  }
})
export default class OfferImageUploadCreation extends InputBase {
  @Prop({ default: '#6B6B6B' }) borderColor?: string;
  @Prop({ default: false }) error!: boolean;
  @Prop({ default: true }) showHelpIcon?: boolean;
  @Prop({ default: true }) uploadAutomatically?: boolean;
  @Prop({ default: 'small-circle' }) type!: string;
  @Prop({ default: 'wideTall' }) size!: string;
  @Prop({ default: '' }) srcDefault!: string;
  @Prop({ default: '' }) cropTitle!: string;
  @Prop(String) name!: string;
  @Prop({ default: null }) returnTo?: [string, ...any[]];
  @Prop({ default: '' }) eventEmitOnUpdateImage?: string;
  @Prop({ default: false }) brandedCoinShape?: boolean;
  @Prop({ default: false }) brandedCoinColor?: boolean;
  @Model('input', {
    type: Object,
    default: initialState
  })
  value!: ImageUploadBlockValue;
  service: UploadService = new UploadService();

  cropMinZoom: number = 1;
  previousOriginalFile: string = '';
  nameFile: string = '';
  originalFile: string = '';
  src: string = this.srcDefault;
  showPreview = !!this.src;
  loading: boolean = false;
  initialCropState: any = null;
  imageId: string = '';
  cropFile: string = '';

  boundaryOptions = this.getSize();

  viewportOptions = {
    ...this.boundaryOptions
  };

  options = {
    type: 'blob',
    size: 'original',
    circle: false,
    quality: 0.85,
    format: 'jpeg'
  };

  get tPrefix() {
    return 'offers.form.imageUpload';
  }

  get cropTitleLabel() {
    if (!this.cropTitle) return this.$t(`${this.tPrefix}.cropTitleDefault`);

    return this.cropTitle;
  }

  onInput(event: HTMLInputEvent) {
    const files = event.target.files || [];

    this.pictureUpload(files);
  }

  saveEditMode({ img, cropState, original }: any) {
    this.loading = true;
    this.$emit('onLoading');
    this.initialCropState = cropState;
    const output = dataURItoBlob(img);
    this.cropFile = img;

    if (original && this.returnTo) {
      this.originalFile = original;
    }

    this.showPreview = true;
    this.$emit('onDone', { link: img });
    segmentIo.track('Image Uploaded');

    this.saveImage(output);
  }

  clickUpload(event: any) {
    event.preventDefault();

    if (this.$refs.input && (this.$refs.input as HTMLInputElement).click)
      (this.$refs.input as HTMLInputElement).click();
  }

  enterEditMode() {
    const {
      initialCropState,
      boundaryOptions,
      viewportOptions,
      saveEditMode,
      onCancelEditMode,
      imageId,
      options,
      cropTitleLabel
    } = this;

    const actualImage = this.src;
    const src = this.originalFile;

    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'cropModal',
        false,
        true,
        true,
        false,
        true,
        null
      ),
      {
        initialState: initialCropState,
        onSave: saveEditMode,
        onCancel: onCancelEditMode,
        boundaryOptions,
        viewportOptions,
        options,
        minZoom: String(this.cropMinZoom),
        scaleImage: true,
        disableBackground: true,
        src,
        title: cropTitleLabel,
        actualImage,
        imageId,
        roundedCropWrapper: true,
        returnTo: this.returnTo,
        radius: '8px',
        borderColor: this.borderColor,
        brandedCoinShape: this.brandedCoinShape,
        brandedCoinColor: this.brandedCoinColor,
        aspectRatio: 0,
        maxZoom: 0.99
      }
    );
  }

  resetInputFile() {
    const containerEl = this.$refs.imageUploadContainer as
      | HTMLElement
      | undefined;

    if (!containerEl) return;

    const inputFileEl = containerEl.querySelector<HTMLInputElement>(
      'input[type="file"]'
    );

    if (inputFileEl) {
      inputFileEl.value = '';
    }
  }

  onCancelEditMode({ img, cropState, imageId, original }: any) {
    this.resetInputFile();

    this.loading = false;

    if (this.returnTo) {
      const output = img;
      this.initialCropState = cropState;
      this.originalFile = original;
      this.imageId = imageId;

      this.$emit('upload', {
        id: imageId,
        publicPath: { large: output, small: output }
      });
      this.$emit('onDone', { link: output });

      this.onUpdateImage({
        id: this.imageId,
        url: output
      });
    } else {
      this.originalFile = String(this.previousOriginalFile);
      this.onUpdateImage({
        id: this.imageId,
        url: this.originalFile
      });
    }

    eventBus.$emit('specialCoinPreviewUpdateComponent');
  }

  onUpdateImage(image: any) {
    if (!this.eventEmitOnUpdateImage) return;

    eventBus.$emit(this.eventEmitOnUpdateImage, image);
  }

  getSize() {
    const aspectRatio = 375 / 234;
    const width = 335;
    const height = width / aspectRatio;
    return {
      width,
      height
    };
  }

  beforeDestroy() {
    this.unBindEvents();
  }

  bindEvents() {
    eventBus.$on('cropmodal-onSave', this.saveEditMode);
    eventBus.$on('cropmodal-onCancel', this.onCancelEditMode);
    eventBus.$on('saveImage', (src: any, width: number, height: number) => {
      const minDimesion = Math.min(width, height);
      this.cropMinZoom = this.boundaryOptions.width / minDimesion;

      this.originalFile = src;
      this.enterEditMode();
    });
  }

  unBindEvents() {
    eventBus.$off('cropmodal-onSave', this.saveEditMode);
    eventBus.$off('cropmodal-onCancel', this.onCancelEditMode);
  }

  upload(data: FormData) {
    let dataToSend;
    this.$showLoaderWithLocker(true);
    this.service
      .upload(data)
      .then(res => {
        const data: IImageData = res.data;
        const image = res.data.publicPath[this.size];
        dataToSend = data.id;
        this.imageId = data.id;
        this.$emit('upload', data);
        this.$emit('onDone', { id: data.id, link: image });
        this.src = image;

        this.onUpdateImage({
          id: data.id,
          url: image
        });
      })
      .catch(err => {
        this.$notification(treatError(err));
      })
      .finally(() => {
        this.$hideLoader();
        this.loading = false;
      });
  }

  saveImage(actualFile: any) {
    this.previousOriginalFile = String(this.originalFile);

    const fd = new FormData();
    const file = actualFile;
    fd.append('data', file);
    if (this.uploadAutomatically) this.upload(fd);

    const imageUrl = URL.createObjectURL(file);

    this.$emit('input', {
      imageFile: file,
      imageUrl,
      imageName: this.nameFile
    });
  }

  dropPicture(event: any) {
    this.pictureUpload(event);
  }

  pictureUpload(files: any) {
    const file = files[0];
    if (!file) return;

    const supportedFileTypes = ['jpeg', 'png', 'jpg', 'svg'];

    if (!supportedFileTypes.some(type => file.type.includes(type))) {
      this.$notification(
        String(this.$t(`${this.tPrefix}.warnNotification`)),
        'warn'
      );
      return;
    }

    this.$showLoaderWithLocker();
    this.initialCropState = null;
    this.nameFile = file.name;
    loadImage(
      file,
      async (canvas: HTMLCanvasElement) => {
        const link = canvas.toDataURL('image/png', 1);
        const image = new Image();
        image.onload = () => {
          const minDimesion = Math.min(image.width, image.height);
          this.cropMinZoom = this.boundaryOptions.width / minDimesion;

          this.originalFile = link;
          this.enterEditMode();

          this.$hideLoader();
        };
        image.src = link;
      },
      { canvas: true, meta: true, orientation: true }
    );
  }

  deleteImage() {
    this.showPreview = false;
    this.src = '';
    this.imageId = '';
    this.originalFile = '';
    this.$emit('delete');
    segmentIo.track('Image Deleted');
  }

  created() {
    this.showPreview = !!this.value.imageUrl;
    this.src = this.value.imageUrl;
    this.nameFile = this.value.imageName || this.nameFile;
  }
}
